import { createStore } from '@datorama/akita';
import { type Design } from 'types/models';

export type DesignState = Design;

const store = createStore<DesignState>({ logo: undefined, banner: undefined, background: undefined, theme: undefined }, { name: 'design' });

export default store;
